import { pointToDev } from "./point-to-prod";
import React from "react";

export default function PointToProdIndicator() {
  return (
    <div
      style={{
        background: "black",
        color: "white",
        padding: 6,
        position: "fixed",
        top: 0,
        left: 0,
        fontSize: "16px",
        zIndex: 99999,
      }}
    >
      Pointed To Prod
      <button
        onClick={pointToDev}
        style={{
          marginLeft: 6,
          background: "white",
          borderRadius: 4,
          padding: 6,
        }}
      >
        Reset
      </button>
    </div>
  );
}
